// extracted by mini-css-extract-plugin
var _1 = "rTv2a";
var _2 = "QCRCo";
var _3 = "jSiZu";
var _4 = "spylp";
var _5 = "aof9Q";
var _6 = "gwVjO";
var _7 = "_C9JE";
var _8 = "Aoy4Z";
var _9 = "s4jZ1";
var _a = "hrnCC";
export { _1 as "accTab", _2 as "accTabContent", _3 as "accTabContentResponsive", _4 as "accTabList", _5 as "accTabListResponsive", _6 as "iconStyle", _7 as "moreButtonIcon", _8 as "overflowButton", _9 as "overflowButtonWithText", _a as "toolTipStyle" }
